<app-login-stepper [loggedInEmail]="data.user?.email" [isCalledFromDialog]="true"
                   (complete)="onSuccessfulLogin()"></app-login-stepper>
